import {
  INIT_LOAD_GALLERY_PENDING,
  INIT_LOAD_GALLERY_FULFILLED,
  INIT_LOAD_GALLERY_REJECTED
} from "../actions/types";

const initialState = {
  initialLoadComplete: false,
  loading: true,
  maxTotal: 0,
  offset: 0,
  images: [],
  error: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case INIT_LOAD_GALLERY_PENDING: {
      return {
        ...state,
        loading: true
      };
    }
    case INIT_LOAD_GALLERY_FULFILLED:
      return {
        ...state,
        initialLoadComplete: true,
        loading: false,
        images: state.images.concat(action.payload.data),
        maxTotal: action.payload.headers["x-wp-total"],
        offset: state.offset + action.payload.data.length
      };
    case INIT_LOAD_GALLERY_REJECTED:
      return {
        ...state,
        error: true,
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/gallery-reducer.js